import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'textFormat',
    standalone: false
})
export class TextFormatPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';

    return value
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase()
      .replace(/\b\w/g, char => char.toUpperCase());
  }

}
